// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"_-ui-careers-lib-ErrorMessage-index-module__errorMessage--2DTG_","icon":"_-ui-careers-lib-ErrorMessage-index-module__icon--ge_uS"};